import React, { useEffect, useState } from "react";
import { Routes, Route, useParams } from 'react-router-dom';
import Loader from "./Loader";
import { AppBar, Box, Tab, Tabs, Toolbar, Typography } from "@mui/material";
import TodayRecords from "./TodayRecords";
import RecordsDataFile from "./TodayRecords";
import Profile from "./Profile";

function Records() {
  const [activeTab, setActiveTab] = useState(0);
  const { tabId } = useParams();
  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };
  useEffect(() => {
    // Scroll to the top of the page on component mount
    window.scrollTo(0, 0);
  }, []); // Empty dependency array to only run on component mount

  useEffect(()=>{
    console.log(typeof tabId);
    setActiveTab(tabId==1 ? 1 : 0);
  },[tabId])
  
  return (
    <div  style={{padding:"0"}}>
    
      <Box  sx={{marginX:'1%',marginTop:"0rem",padding:'12px 0px'}}>
        <Tabs value={activeTab} onChange={handleTabChange}
         textColor="inherit" // Use "inherit" here to allow custom styling
         indicatorColor="primary" // Use "primary" here; we'll customize it using sx
         sx={{
          position:"sticky",top:"3.75rem",zIndex:"10",background:"#fff",marginTop:"-0.7rem",marginBottom:"0.9rem"
          ,padding:"10px",
          borderRadius:"12px",
           '& .MuiTab-root': {
             color: '#000', // Default color for all tabs
           },
           '& .Mui-selected': {
             color: '#0576FC', // Custom color for the active tab
           },
           '& .MuiTabs-indicator': {
             backgroundColor: '#0576FC', // Custom color for the indicator
           },
         }}>
          <Tab label="Data File Status" />
          <Tab label="Curation Status" />
        </Tabs>
        {activeTab === 0 && (
          <Box>
            <TodayRecords refresh={activeTab} />
          </Box>
        )}
        {activeTab === 1 && (
          <Box >
            <TodayRecords refresh={activeTab} />
          </Box>
        )}
      </Box>
    </div>
  );
}

export default Records;